import { useDeleteUnderwearPromotion } from '@/api/underwear-promotion/underwear-promotion.hooks';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { getS3Url } from '@/config/s3.config';
import { UnderwearPromotionResponse } from '@repo/types/src/underwear-promotion';
import { Trash } from 'lucide-react';
import { toast } from 'sonner';
import { AddUnderwearPromotion } from './AddUnderwearPromotion';

export const UnderwearPromotionCard = (
  promotion: UnderwearPromotionResponse,
) => {
  const deleteMutation = useDeleteUnderwearPromotion();

  const handleDelete = () => {
    deleteMutation.mutate(promotion.id, {
      onSuccess: () =>
        toast.success('Promotion supprimée !', { duration: 3000 }),
      onError: () =>
        toast.error('Erreur lors de la suppression', { duration: 3000 }),
    });
  };

  return (
    <Card className="overflow-hidden w-72 h-fit">
      <CardContent className="p-0 aspect-[4/3] w-full">
        <img
          src={getS3Url(promotion.image)}
          alt={promotion.name}
          className="object-cover w-full h-full"
        />
      </CardContent>
      <CardFooter className="flex flex-col items-start gap-2 pt-3 pb-3">
        <p className="font-semibold text-sm">{promotion.name}</p>
        <p className="text-sm text-zinc-600 line-clamp-2">
          {promotion.description}
        </p>
        <p className="text-xs text-zinc-400">
          Délai : {promotion.timeStart}s · Occurrence : {promotion.occurrence} ·
          Nième ouverture : {promotion.nthOpen}
        </p>
        <div className="flex gap-2 w-full justify-end">
          <AddUnderwearPromotion promotion={promotion} />
          <Button size="icon" variant="ghost" onClick={handleDelete}>
            <Trash size={16} color="red" />
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
};
